// extracted by mini-css-extract-plugin
export default {"popupContainer":"orderLoader-module__popupContainer__Mv8m8","loaderText":"orderLoader-module__loaderText__wyyp9"};